import moment, { Moment } from "moment-timezone";
import "moment/locale/ru";
export const TZ_MSK = "Europe/Moscow";

export const moscowTime = (
  value: number | Date,
  { format = "DD.MM.YY" }
): string => {
  return moment.tz(value, TZ_MSK).format(format);
};

export const mskTimeFormat = (
  value: number,
  format: string = "YYYY-MM-DD"
): string => {
  return moment.tz(value, TZ_MSK).format(format);
};

export const utcTimeFormat = (
  value: number | Moment,
  format: string = "YYYY-MM-DD"
): string => {
  return moment(value).utc().format(format);
};

export const toServerDate = (
  value: number | Moment,
  format: string = "YYYY-MM-DD"
): string => {
  return moment(value).utc().format(format);
};

export const getUtcFormat = (
  value: number | Moment,
  format: string = "YYYY-MM-DD"
): string => {
  return moment(value).utc().format(format);
};

export const getUtcToday = (format: string = "YYYY-MM-DD"): string => {
  return moment.utc().format(format);
};

export const getUtcTomorrow = (format: string = "YYYY-MM-DD"): string => {
  return moment().add(1, "days").utc().format(format);
};

export const getUtcYesterday = (format: string = "YYYY-MM-DD"): string => {
  return moment().add(-1, "days").utc().format(format);
};

export const getCurrentServerTime = (): Moment => {
  return moment.tz(
    new Date().getTime() +
    (window.SERVER_TIME_DELTA ? window.SERVER_TIME_DELTA : 0),
    TZ_MSK
  );
};

// export const _today = (): Moment => {
//   return moment().tz(TZ_MSK);
// };

export const todayUtc = (): Moment => {
  return moment.utc();
};

// export const getPeriodForToday = (): [Moment, Moment] => {
//   return [
//     moment().tz(TZ_MSK).startOf("day"),
//     moment().tz(TZ_MSK).add(1, "day").startOf("day"),
//   ];
// };

export const time = (unixTsInSec: number): Moment => {
  return moment.utc(unixTsInSec * 1000);
};
